import Api from "../Utils/Axios";

export const GetDiscoverList = async (data) => {
  const response = await Api.get("discovers/", { params: data });
  return response.data;
};

export const AddImages = async (data) => {
  const response = await Api.post("general/uploadFiles/?returnUrls=true", data);
  return response.data;
};

export const CreateDiscover = async (data) => {
  const response = await Api.post("discovers/", data);
  return response.data;
};

export const DeleteDiscover = async (data) => {
  const response = await Api.delete("discovers/", { data: data });
  return response.data;
};

export const GetSingleDiscover = async ({ Id }) => {
  const response = await Api.get(`discovers/${Id}`);
  return response.data;
};

export const UpdateDiscover = async (data) => {
  const response = await Api.put("discovers/", data);
  return response.data;
};

export const DragAndDropDiscovers = async (data) => {
  const response = await Api.post("discovers/changeOrder", data);
  return response.data;
};
